import { render, staticRenderFns } from "./jgqs.vue?vue&type=template&id=3e5c8e7f&scoped=true&"
import script from "./jgqs.vue?vue&type=script&lang=js&"
export * from "./jgqs.vue?vue&type=script&lang=js&"
import style0 from "./jgqs.vue?vue&type=style&index=0&id=3e5c8e7f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5c8e7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e5c8e7f')) {
      api.createRecord('3e5c8e7f', component.options)
    } else {
      api.reload('3e5c8e7f', component.options)
    }
    module.hot.accept("./jgqs.vue?vue&type=template&id=3e5c8e7f&scoped=true&", function () {
      api.rerender('3e5c8e7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/scyxDrawer/components/jgqs.vue"
export default component.exports